import api from '@/services/api/client';

export interface ReplacementChainNode {
  registrationNumber: string;
  vehicleId: number | null;
  status: string | null;
}

export interface ReplacementChainResult {
  nodes: ReplacementChainNode[];
  currentIndex: number;
  anchorRegistrationNumber: string;
}

export async function fetchReplacementChain(params: {
  registrationNumber?: string;
  vehicleId?: number;
}): Promise<ReplacementChainResult> {
  const search = new URLSearchParams();
  if (params.registrationNumber?.trim()) {
    search.set('registration_number', params.registrationNumber.trim());
  }
  if (params.vehicleId != null && params.vehicleId > 0) {
    search.set('vehicle_id', String(params.vehicleId));
  }
  const res = await api.get<{ success: boolean; data: ReplacementChainResult }>(
    `/api/deque/replacement-chain?${search.toString()}`
  );
  return res.data.data;
}
